/** API route map: URLS.Controller.SovrenResumeParsing */
export const SovrenResumeParsing = {
      Name: 'ResumeParser/',
      ParseResume: '',
};
